export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'ellipsisResize',
	namespaced: true,
	state: {
		resize: 0
	},
	mutations: {
		setResize(state, value) {
			state.resize = parseInt(value);
		}
	},
	getters: {
		resize: state => state.resize
	}
};
